import React from 'react';
import { FaPlus, FaTrash, FaDownload, FaUndo, FaCopy } from 'react-icons/fa';
import { useLang } from '../i18n/LangContext';
import '../styles/DataGrid.css';

const GridToolbar = ({ gridRef, rowData, setRowData, newRowTemplate, entityName = '행' }) => {
  const { t, lang } = useLang();

  const addRow = () => {
    const newRow = typeof newRowTemplate === 'function' ? newRowTemplate(rowData) : { ...newRowTemplate };
    setRowData(prev => [...prev, newRow]);
    setTimeout(() => {
      if (gridRef.current?.api) {
        gridRef.current.api.ensureIndexVisible(rowData.length, 'bottom');
        const lastIdx = rowData.length;
        gridRef.current.api.setFocusedCell(lastIdx, gridRef.current.api.getAllDisplayedColumns()[1]?.getColId());
        gridRef.current.api.startEditingCell({
          rowIndex: lastIdx,
          colKey: gridRef.current.api.getAllDisplayedColumns()[1]?.getColId(),
        });
      }
    }, 100);
  };

  const deleteSelected = () => {
    if (!gridRef.current?.api) return;
    const selected = gridRef.current.api.getSelectedRows();
    if (selected.length === 0) {
      alert(lang === 'ko' ? '삭제할 행을 선택해주세요.' : '削除する行を選択してください。');
      return;
    }
    const msg = lang === 'ko'
      ? `선택한 ${selected.length}개 ${entityName}을(를) 삭제하시겠습니까?`
      : `選択した${selected.length}件の${entityName}を削除しますか？`;
    if (window.confirm(msg)) {
      const selectedSet = new Set(selected.map(r => JSON.stringify(r)));
      setRowData(prev => prev.filter(r => !selectedSet.has(JSON.stringify(r))));
    }
  };

  const exportCsv = () => {
    if (!gridRef.current?.api) return;
    gridRef.current.api.exportDataAsCsv({
      fileName: `${entityName}_export_${new Date().toISOString().slice(0, 10)}.csv`,
      processCellCallback: (params) => params.value,
    });
  };

  const copySelected = () => {
    if (!gridRef.current?.api) return;
    const selected = gridRef.current.api.getSelectedRows();
    if (selected.length === 0) {
      alert(lang === 'ko' ? '복사할 행을 선택해주세요.' : 'コピーする行を選択してください。');
      return;
    }
    const cols = gridRef.current.api.getAllDisplayedColumns();
    const header = cols.map(c => c.getColDef().headerName).join('\t');
    const rows = selected.map(row =>
      cols.map(c => row[c.getColId()] ?? '').join('\t')
    ).join('\n');
    navigator.clipboard.writeText(header + '\n' + rows).then(() => {
      const msg = lang === 'ko'
        ? `${selected.length}개 행이 클립보드에 복사되었습니다.`
        : `${selected.length}行をクリップボードにコピーしました。`;
      alert(msg);
    });
  };

  return (
    <div className="grid-toolbar">
      <div className="grid-toolbar-left">
        <button className="grid-tool-btn grid-tool-add" onClick={addRow}>
          <FaPlus /> {t.grid.add}
        </button>
        <button className="grid-tool-btn grid-tool-delete" onClick={deleteSelected}>
          <FaTrash /> {t.grid.delete}
        </button>
        <div className="grid-tool-divider" />
        <button className="grid-tool-btn" onClick={copySelected}>
          <FaCopy /> {t.grid.copy}
        </button>
        <button className="grid-tool-btn" onClick={exportCsv}>
          <FaDownload /> {t.grid.export}
        </button>
      </div>
      <div className="grid-toolbar-right">
        <span className="grid-tool-info">
          {lang === 'ko' ? `총 ${rowData.length}개 ${entityName}` : `合計 ${rowData.length}件 ${entityName}`}
        </span>
      </div>
    </div>
  );
};

export default GridToolbar;
